import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=00f5abca&scoped=true"
import script from "./InfoCard.vue?vue&type=script&lang=ts"
export * from "./InfoCard.vue?vue&type=script&lang=ts"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=00f5abca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f5abca",
  null
  
)

export default component.exports